export const setAreaVirtualPaged = (areaVirtualPaged) => {
    return {
        type: 'SET_AREA_VIRTUAL_PAGED',
        areaVirtualPaged,
    };
};

export const setAreaVirtual = (areaVirtual) => {
    return {
        type: 'SET_AREA_VIRTUAL',
        areaVirtual
    };
};

export const setPositionPaged = (positionPaged) => {
    return {
        type: 'SET_POSITION_PAGED',
        positionPaged,
    };
};

export const setAviexpPaged = (aviexpPaged) => {
    return {
        type: 'SET_AVIEXP_PAGED',
        aviexpPaged,
    };
};

export const setContainerPaged = (containerPaged) => {
    return {
        type: 'SET_CONTAINER_PAGED',
        containerPaged,
    };
};

export const setContainerFilters = (containerFilters) => {
    return {
        type: 'SET_CONTAINER_FILTERS',
        containerFilters
    };
}

export const setContainer = (container) => {
    return {
        type: 'SET_CONTAINER',
        container
    };
};

export const setUnloadLocationPaged = (unloadLocationPaged) => {
    return {
        type: 'SET_UNLOAD_LOCATION_PAGED',
        unloadLocationPaged,
    };
};

export const setUnloadLocationList = (unloadLocationList) => {
    return {
        type: 'SET_UNLOAD_LOCATION_ALL',
        unloadLocationList,
    };
};

export const setUnloadLocation = (unloadLocation) => {
    return {
        type: 'SET_UNLOAD_LOCATION',
        unloadLocation,
    };
};

export const setCriticalPart = (item) => {
    return {
        type: 'SET_CRITICAL_PART',
        item,
    };
};

export const setCriticalPartsPaged = (itemsPaged) => {
    return {
        type: 'SET_CRITICAL_PARTS_PAGED',
        itemsPaged,
    };
};

export const setCriticalPartsFilters = (filters) => {
    return {
        type: 'SET_CRITICAL_PARTS_FILTERS',
        filters
    };
}

export const setCriticalPartEmails = (items) => {
    return {
        type: 'SET_CRITICAL_PART_EMAILS',
        items
    };
}

export const setContainerStatus = (items) => {
    return {
        type: 'SET_CONTAINER_STATUS',
        items
    };
}

export const setContainerTypes = (items) => {
    return {
        type: 'SET_CONTAINER_TYPES',
        items
    };
}
export const setContainerType = (item) => {
    return {
        type: 'SET_CONTAINER_TYPE',
        item
    };
}

export const setContainerSizes = (items) => {
    return {
        type: 'SET_CONTAINER_SIZES',
        items
    };
}

export const setContainerSize = (item) => {
    return {
        type: 'SET_CONTAINER_SIZE',
        item
    };
}

export const setPlantConfig = (item) => {
    return {
        type: 'SET_PLANT_CONFIG',
        item
    };
}

export const setBusinessHoursConfig = (item) => {
    return {
        type: 'SET_BUSINESS_HOURS_CONFIG',
        item
    };
}


export const setMaritimeCompanyAll = (maritimeCompanyList) => {
    return {
        type: 'SET_MARITIME_COMPANY_ALL',
        maritimeCompanyList,
    };
};


export const setPositionsAll = (positions) => {
    return {
        type: 'SET_POSITIONS_ALL',
        positions,
    };
};


export const setMaritimeCompanyPaged = (maritimeCompanyPaged) => {
    return {
        type: 'SET_MARITIME_COMPANY_PAGED',
        maritimeCompanyPaged,
    };
};

export const setMaritimeCompany = (maritimeCompany) => {
    return {
        type: 'SET_MARITIME_COMPANY',
        maritimeCompany,
    };
};

export const setHarborAll = (harborList) => {
    return {
        type: 'SET_HARBOR_ALL',
        harborList,
    };
};

export const setHarborPaged = (harborPaged) => {
    return {
        type: 'SET_HARBOR_PAGED',
        harborPaged,
    };
};

export const setHarbor = (harbor) => {
    return {
        type: 'SET_HARBOR',
        harbor,
    };
};

export const setFreetimePaged = (freetimePaged) => {
    return {
        type: 'SET_FREETIME_PAGED',
        freetimePaged,
    };
};

export const setFreetime = (freetime) => {
    return {
        type: 'SET_FREETIME',
        freetime,
    };
};

export const setCoveragePartNumberPaged = (coveragePartNumberPaged) => {
    return {
        type: 'SET_COVERAGE_PARTNUMBER_PAGED',
        coveragePartNumberPaged,
    };
};

export const setCoveragePartNumber = (coveragePartNumber) => {
    return {
        type: 'SET_COVERAGE_PARTNUMBER',
        coveragePartNumber,
    };
};

export const setContainerHistoryPaged = (containerHistoryListPaged) => {
    return {
        type: 'SET_CONTAINER_HISTORY_PAGED',
        containerHistoryListPaged,
    };
};

export const setMdrPaged = (mdrPaged) => {
    return {
        type: 'SET_MDR_PAGED',
        mdrPaged,
    };
};

export const setMdr = (mdr) => {
    return {
        type: 'SET_MDR',
        mdr
    };
};

export const setContainerItemPaged = (containerItemPaged) => {
    return {
        type: 'SET_CONTAINER_ITEM_PAGED',
        containerItemPaged,
    };
};

export const setContainersItemPartNumberPaged = (containersItemPartNumberPaged) => {
    return {
        type: 'SET_CONTAINER_ITEM_PARTNUMBER_PAGED',
        containersItemPartNumberPaged,
    };
};

export const setAlertsPaged = (alertsEmailPaged) => {
    return {
        type: 'SET_ALERT_EMAIL_PAGED',
        alertsEmailPaged,
    };
}

export const setCoveragePaged = (coveragePaged) => {
    return {
        type: 'SET_COVERAGE_PAGED',
        coveragePaged,
    };
};

export const setPartNumberSupplierPaged = (partNumberSupplierPaged) => {
    return {
        type: 'SET_PARTNUMBER_SUPPLIER_PAGED',
        partNumberSupplierPaged,
    };
};

export const setPartNumberSupplier = (partNumberSupplier) => {
    return {
        type: 'SET_PARTNUMBER_SUPPLIER',
        partNumberSupplier
    };
};
